import { Box, Skeleton, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Disclosure from 'modules/payroll_bundle/components/Disclosure'

import './index.styles.css'
const SkeletonLoader = () => {
  return (
    <Box gap="s8" style={{ flex: '1' }}>
      <Box height="s32" flexDirection="row" alignItems="center" paddingX="s8">
        <Text.Normal weight="medium" size="300">
          {i18n.t('payroll_bundle.payroll_dashboard.payment_summary.widget_title')}
        </Text.Normal>
        <Disclosure
          tooltipText={i18n.t(
            'payroll_bundle.payroll_dashboard.payment_summary.heading_tooltip.tooltip_v2'
          )}
        />
      </Box>
      <Box
        style={{ flex: '1' }}
        flexDirection="row"
        border={{ all: { color: 'grey400', width: 's1', style: 'solid' } }}
        borderRadius={{ all: 'abs016' }}
        minHeight="s200"
      >
        <Box style={{ flex: '1' }} gap="s16" padding={'s24'} justifyContent="spaceBetween">
          <Box gap="s16" minWidth="s200">
            <Box>
              <Box flexDirection="row" gap="s6">
                <Skeleton height="s24" width="s24" />
                <Text size="300" weight="medium" color="grey1000">
                  /
                </Text>{' '}
                <Skeleton height="s24" width="s32" />
              </Box>
              <Text size="200">
                {i18n
                  .t('payroll_bundle.payroll_dashboard.payment_summary.employees_paid')
                  .toLowerCase()}
              </Text>
            </Box>
            <Box>
              <Skeleton height="s24" width="s96" />
              <Text size="200">
                {i18n
                  .t('payroll_bundle.payroll_dashboard.payment_summary.total_paid')
                  .toLowerCase()}
              </Text>
            </Box>
          </Box>

          <Skeleton height="s24" width="s120" />
        </Box>
        <Box minWidth="s1" width="s1" className={'PayrollSummaryWidget_lineBackground'} />
        <Box
          paddingY={'s32'}
          paddingX={'s64'}
          justifyContent="spaceBetween"
          alignItems="flexEnd"
          style={{ flex: '2' }}
          flexDirection="row"
        >
          <Skeleton height="s96" width="s8" />
          <Skeleton height="s80" width="s8" />
          <Skeleton height="s120" width="s8" />
        </Box>
      </Box>
    </Box>
  )
}

export default SkeletonLoader
